var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2871.89 2871.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-3);}.cls-3{fill:url(#linear-gradient-4);}.cls-4{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1435.95,
    y1: 0,
    x2: 1435.95,
    y2: 2871.89,
    gradientTransform: "translate(0 2871.89) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fff",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#fff",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fff",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#fff",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 772.2,
    y1: 1772.55,
    x2: 772.2,
    y2: 1099.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fff",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fff",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#fff",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fff",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1358.1,
    x2: 1358.1,
    y2: 1117.35,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2037.14,
    y1: 1754.55,
    x2: 2037.14,
    y2: 1117.35,
    xlinkHref: "#linear-gradient-2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1435.95,0c-193.85,0-381.9,37.97-558.94,112.84-85.09,35.99-167.15,80.53-243.92,132.39-76.04,51.37-147.54,110.36-212.52,175.34s-123.97,136.48-175.34,212.52c-51.86,76.76-96.4,158.83-132.39,243.92C37.97,1054.04,0,1242.1,0,1435.95s37.97,381.9,112.84,558.94c35.99,85.09,80.53,167.15,132.39,243.92,51.37,76.04,110.36,147.54,175.34,212.52,64.98,64.98,136.48,123.97,212.52,175.34,76.76,51.86,158.83,96.41,243.92,132.39,177.03,74.88,365.08,112.84,558.94,112.84s381.9-37.97,558.94-112.84c85.09-35.99,167.15-80.53,243.92-132.39,76.04-51.37,147.54-110.36,212.52-175.34s123.97-136.48,175.34-212.52c51.86-76.76,96.41-158.83,132.39-243.92,74.88-177.03,112.84-365.08,112.84-558.94s-37.97-381.9-112.84-558.94c-35.99-85.09-80.53-167.15-132.39-243.92-51.37-76.04-110.36-147.54-175.34-212.52-64.98-64.98-136.48-123.97-212.52-175.34-76.77-51.86-158.83-96.4-243.92-132.39C1817.85,37.97,1629.8,0,1435.95,0Zm0,2869.89c-193.58,0-381.37-37.91-558.16-112.69-84.97-35.94-166.92-80.42-243.58-132.21-75.93-51.3-147.33-110.21-212.22-175.1-64.89-64.89-123.8-136.29-175.1-212.22-51.79-76.66-96.27-158.61-132.21-243.58C39.91,1817.32,2,1629.53,2,1435.95s37.91-381.37,112.69-558.16c35.94-84.97,80.42-166.92,132.21-243.58,51.3-75.93,110.21-147.33,175.1-212.22s136.29-123.8,212.22-175.1c76.66-51.79,158.61-96.27,243.58-132.21C1054.57,39.91,1242.36,2,1435.95,2s381.37,37.91,558.16,112.69c84.97,35.94,166.92,80.42,243.58,132.21,75.93,51.3,147.33,110.21,212.22,175.1,64.89,64.89,123.8,136.29,175.1,212.22,51.79,76.66,96.27,158.61,132.21,243.58,74.77,176.78,112.69,364.58,112.69,558.16s-37.91,381.37-112.69,558.16c-35.94,84.97-80.42,166.92-132.21,243.58-51.3,75.93-110.21,147.33-175.1,212.22-64.89,64.89-136.29,123.8-212.22,175.1-76.66,51.79-158.61,96.27-243.58,132.21-176.78,74.77-364.57,112.69-558.16,112.69Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M963.9,1601.55c0,27-5.26,51.16-15.75,72.45-10.5,21.3-24.46,39.3-41.85,54-17.41,14.71-37.95,25.8-61.65,33.3-23.71,7.5-48.46,11.25-74.25,11.25-39.6,0-75.75-7.06-108.45-21.15-32.71-14.09-59.85-33.14-81.45-57.15l15.3-13.5c22.8,24.61,49.35,43.06,79.65,55.35,30.29,12.3,61.65,18.45,94.05,18.45,23.4,0,45.59-3.45,66.6-10.35,21-6.89,39.6-16.79,55.8-29.7,16.2-12.9,28.94-28.8,38.25-47.7,9.29-18.9,13.95-40.64,13.95-65.25s-5.11-45.29-15.3-62.1c-10.21-16.79-23.4-31.19-39.6-43.2-16.2-12-34.65-22.05-55.35-30.15-20.7-8.1-41.55-15.44-62.55-22.05-26.41-8.4-50.55-17.24-72.45-26.55-21.91-9.3-40.81-20.7-56.7-34.2-15.91-13.5-28.21-29.7-36.9-48.6-8.7-18.9-13.05-41.85-13.05-68.85s5.25-49.95,15.75-70.65c10.49-20.7,24.75-38.1,42.75-52.2,18-14.09,38.84-24.89,62.55-32.4,23.7-7.5,48.74-11.25,75.15-11.25,32.4,0,63.14,6.16,92.25,18.45,29.09,12.3,52.95,29.85,71.55,52.65l-15.3,13.5c-16.8-21-38.25-37.35-64.35-49.05-26.1-11.7-54.45-17.55-85.05-17.55-21.6,0-42.75,3.01-63.45,9-20.7,6-39.46,15.16-56.25,27.45-16.8,12.3-30.3,27.76-40.5,46.35-10.21,18.61-15.3,40.5-15.3,65.7s4.5,45.45,13.5,62.55c9,17.1,21,31.66,36,43.65,14.99,12.01,31.95,21.91,50.85,29.7,18.9,7.8,38.25,15,58.05,21.6,27,9,52.2,18.16,75.6,27.45,23.4,9.31,43.95,20.56,61.65,33.75,17.69,13.21,31.5,29.25,41.4,48.15,9.9,18.9,14.85,41.85,14.85,68.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1588.5,1614.6c-8.41,31.5-22.2,58.95-41.4,82.35-19.21,23.4-44.25,41.85-75.15,55.35-30.91,13.5-68.85,20.25-113.85,20.25s-82.96-6.75-113.85-20.25c-30.91-13.5-55.95-31.95-75.15-55.35-19.21-23.4-33-50.85-41.4-82.35-8.41-31.5-12.6-65.25-12.6-101.25v-396h19.8v392.4c0,25.2,2.54,52.06,7.65,80.55,5.09,28.5,15.6,54.9,31.5,79.2,15.89,24.3,38.39,44.55,67.5,60.75,29.1,16.2,67.95,24.3,116.55,24.3s85.64-7.79,114.75-23.4c29.09-15.59,51.75-35.55,67.95-59.85,16.2-24.3,27-50.7,32.4-79.2,5.4-28.49,8.1-55.94,8.1-82.35v-392.4h19.8v396c0,36-4.21,69.75-12.6,101.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2262.59,1754.55l-457.2-612h-2.7v612h-19.8v-637.2h27.9l458.1,611.1h2.7v-611.1h19.8v637.2h-28.8Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.53dc805bea4de297eef2d3673f44d551.svg";
export { ForwardRef as ReactComponent };